import { DrawerComponent, LoaderComponent } from "@/components";
import { AddressModule, Stages } from "@/components/Address";

export const PersonalAddressDrawer = ({
  fieldName,
  handleDrawer,
  isLoading,
  open,
  handleOnSubmit,
}) => {
  return (
    <DrawerComponent handleDrawer={handleDrawer} open={open}>
      <AddressModule>
        <AddressModule.Container start = {Stages.map}>
          <LoaderComponent open={isLoading} />
          {/* <AddressModule.Content
            keyName={Stages.location}
            component={
              <AddressModule.AddressAutosuggestion
                fieldName={fieldName}
                nextStage={Stages.map}
              />
            }
          /> */}
          <AddressModule.Content
            keyName={Stages.map}
            component={<AddressModule.Map autosuggestion/>}
          />
          <AddressModule.Content
            keyName={Stages.addressFields}
            component={
              <AddressModule.AddressFields
                resetStateOnSubmit={false}
                fieldLabels={{
                  line2: "House No/Floor No – Tower/Apartment/Building",
                  line3: "Street/Locality/Area",
                  landmark: "Landmark",
                }}
                handleOnSubmit={handleOnSubmit}
              />
            }
          />
        </AddressModule.Container>
      </AddressModule>
    </DrawerComponent>
  );
};
